import request from '@/utils/request'
var actionMap = {
    itemClick: 'block-item-click',// 首页内容点击
    mainView: 'discover-view', // 首页浏览
    albumView: 'alibum-view', // 专辑详情页
    blockView: 'block-view', // 块信息浏览
    tryPlay: 'trysee-click', // 试看点击
    noPay: 'nopay-click', // 没有支付点击播放
    play: 'play-click', // 播放点击
    pay: 'pay-click' // 发起支付点击
}
export function flowlog (type, query) {
  query['action'] = actionMap[type]
  return request({
    url: '/flow/log',
    method: 'get',
    params: query
  })
}

export function report (vid, aid) {
  return request({
    url: '/flow/reportPlay',
    method: 'get',
    params: {vid: vid, aid: aid}
  })
}